import * as AppConst from '@/store/modules/Constants';
import { HTTPAction } from '../../store/modules/app/types';
import { apiRequestCustomConfig } from '../../store/modules/ApiRequestHelper';
import { TenantHelpers } from '@/utils/tenant-helpers';
import { BillingStatus } from '@/modules/subscription/types';
import auth from '../../auth/authService';
import authConfig from '../../../auth_config.json';

export const actions = {
  // Submit jig to Community.
  async submitToSlackChannel(context, payload) {
    if (!payload || Object.keys(payload).length === 0) {
      return Promise.reject('invalid payload passed to submitToSlackChannel, payload should be JigMetaData');
    } else {
      const message = craftSlackMessage(context, payload);
      const config = {
        headers: {
          // Do not set Content-Type to json though it's in documentation, it will get into CORS error.
          // 'Content-Type': 'application/json',
        },
      };
      const request = {
        action: HTTPAction.POST,
        url: AppConst.communitySlackWebhook,
        // Stringify the json data otherwise will get into CORS error
        body: JSON.stringify(message),
      };

      return apiRequestCustomConfig(
        request,
        context,
        '',
        'submit jig to community',
        config
      );
    }
  },
};

function isProUser(myTenantToken) {
  const isProSubscriptionActive =
    myTenantToken.billing_status === undefined ||
    myTenantToken.billing_status === null ||
    [
      '',
      BillingStatus.Paid,
      BillingStatus.Trial,
      BillingStatus.UserUnsubscribed,
    ].includes(myTenantToken.billing_status);

  const isGuest = myTenantToken.rol.find((r) => r.indexOf('role_guest') >= 0);

  return myTenantToken.tenant_type === 'pro' && isProSubscriptionActive && !isGuest;
}

function craftSlackMessage(context, jigMetadata) {
  const username = auth.profile.email;
  const tenantTokens = auth.tenants;
  const app = context.rootState.app;
  let myTenant = app.myTenant;
  let myTenantToken = app.myTenantToken;
  let userDetails = '';
  let isJigSpaceStaff = false;

  myTenantToken = TenantHelpers.GetTenantTokenByTenantID(tenantTokens, myTenant.ID)

  if (myTenant.Name === TenantHelpers.jigSpaceStaffTenantName) {
    userDetails = `${username} :jig: (STAFF)`;
    isJigSpaceStaff = true;
  } else if (isProUser(myTenantToken)) {
    userDetails = `${username} (PRO)`;
  }

  const userTypeDisplayName = isJigSpaceStaff ? 'legendary artist' : 'the very talented';

  const title = `(${authConfig.dashboardEnv}, dashboard)`;

  const jigVisibility = jigMetadata.ProjectVisibility === AppConst.jigVisibilityLink ? 'unlisted' : jigMetadata.ProjectVisibility;
  const jigThumbnailUrl = jigMetadata.ThumbnailURL;

  const attachmentTitle = `${jigMetadata.ProjectName}, by ${userTypeDisplayName} ${userDetails}`
  const attachmentText = `${jigMetadata.ProjectDescription ? `${jigMetadata.ProjectDescription}\n` : ''}Link (${jigVisibility}): ${jigMetadata.DeeplinkURL}`;

  const slackMessage = {
    icon_emoji: ':tada:',
    text: title,
    attachments: [craftSlackAttachments(attachmentTitle, attachmentText, '#0099FF', jigThumbnailUrl)],
  };

  return slackMessage;
}

function craftSlackAttachments(
  title,
  text,
  color,
  image_url
) {
  const attachment = {
    title,
    text,
    color,
    image_url: image_url === '/images/jigs/jig-placeholder-color.png' ? '' : `${AppConst.apiDomain}${image_url}`,
  }

  return attachment;
}
